import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import Err from "../../../routes/error";
import { SET_FILOGIX_DETAILS, SET_SYNCED_EMAILS, SET_BROKERAGE_OVERRIDES, SET_BROKERAGE_DATA, SET_BROKERAGE_FAQ, SET_PERSONAL_FAQ, SET_DEFAULT_EMAIL, DELETE_SYNC_EMAIL, SET_SYNCED_CALENDARS, SET_CALENDAR_SYNC, SET_EXPERT_LENDER_DETAILS, SET_BROKERAGE_BOARDS } from "./settings-mutations";
import { getFilogixDetails, updateFilogixDetails, getSyncedEmails, changePassword, getBrokerageOverrides, updateBrokerageOverrides, getBrokerageData, updateBrokerageData, updateBrokerageLogo, removePersonalLogo, removeBrokerageLogo, getSignedURL, updatePersonalStyles, updateBrokerageStyles, getPersonalFaq, getBrokerageFaq, updatePersonalFaq, updateBrokerageFaq, validateSyncedEmail, getSyncedCalendars, removeSyncedEmail, toggleCalendarSync, updateDefaultEmail, pullFilogixDetailsFromExpert, verifyExpertProfileNumber, getBrokerageBoards, updateBrokerageBoards, renewTokenNylas, updateRefreshToken } from "../api/settings-api";
import { NYLAS_API, S3_BUCKET_URL, showToast } from "@Shared/utils/constants";
import { putS3Data } from "@Shared/utils/ajax";
import { normalize } from "normalizr";
import Amplitude from "@Shared/@Utils/amplitude";
import { emailsSchema, calendarsSchema } from "./settings-schema";
import { isEmpty } from "lodash";
export const LOAD_FILOGIX_DETAILS = "LOAD_FILOGIX_DETAILS";
export const UPDATE_FILOGIX_DETAILS = "UPDATE_FILOGIX_DETAILS";
export const LOAD_SYNCED_EMAILS = "LOAD_SYNCED_EMAILS";
export const UPDATE_SYNCED_EMAILS = "LOAD_SYNCED_EMAILS";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const LOAD_BROKERAGE_OVERRIDES = "LOAD_BROKERAGE_OVERRIDES";
export const UPDATE_BROKERAGE_OVERRIDES = "UPDATE_BROKERAGE_OVERRIDES";
export const LOAD_BROKERAGE_DATA = "LOAD_BROKERAGE_DATA";
export const UPDATE_BROKERAGE_DATA = "UPDATE_BROKERAGE_DATA";
export const LOAD_BROKERAGE_BOARDS = "LOAD_BROKERAGE_BOARDS";
export const UPDATE_BROKERAGE_BOARDS = "UPDATE_BROKERAGE_BOARDS";
export const UPDATE_OVERRIDES = "UPDATE_OVERRIDES";
export const UPLOAD_LOGO = "UPLOAD_LOGO";
export const UPDATE_BROKERAGE_LOGO = "UPDATE_BROKERAGE_LOGO";
export const UPDATE_NAV_LOGO = "UPDATE_NAV_LOGO";
export const REMOVE_BROKERAGE_LOGO = "REMOVE_BROKERAGE_LOGO";
export const REMOVE_PERSONAL_LOGO = "REMOVE_PERSONAL_LOGO";
export const UPDATE_PERSONAL_STYLES = "UPDATE_PERSONAL_STYLES";
export const UPDATE_BROKERAGE_STYLES = "UPDATE_BROKERAGE_STYLES";
export const LOAD_PERSONAL_FAQ = "LOAD_PERSONAL_FAQ";
export const LOAD_BROKERAGE_FAQ = "LOAD_BROKERAGE_FAQ";
export const UPDATE_BROKERAGE_FAQ = "UPDATE_BROKERAGE_FAQ";
export const UPDATE_PERSONAL_FAQ = "UPDATE_PERSONAL_FAQ";
export const VALIDATE_SYNCED_EMAIL = "VALIDATE_SYNCED_EMAIL";
export const UPDATE_DEFAULT_EMAIL = "UPDATE_DEFAULT_EMAIL";
export const DELETE_SYNCED_EMAIL = "DELETE_SYNCED_EMAIL";
export const UPDATE_SYNCED_CALENDARS = "UPDATE_SYNCED_CALENDARS";
export const LOAD_SYNCED_CALENDARS = "LOAD_SYNCED_CALENDARS";
export const REFRESH_TOKEN_NYLAS = "REFRESH_TOKEN_NYLAS";
export const UPDATE_REFRESH_TOKEN = "UPDATE_REFRESH_TOKEN";
export const LOAD_EXPERT_DETAILS = "LOAD_EXPERT_DETAILS";
export const VERIFY_EXPERT_PROFILE_NUMBER = "VERIFY_EXPERT_PROFILE_NUMBER";
const actions = {
  [LOAD_FILOGIX_DETAILS]: async context => {
    try {
      const filogixDetails = await getFilogixDetails();
      context.commit(SET_FILOGIX_DETAILS, filogixDetails);
    } catch (e) {
      Err.handle(e, {}, "failedToLoadFilogixDetails");
    }
  },
  [UPDATE_FILOGIX_DETAILS]: async (context, filogixDetails) => {
    const {
      expertLoginId,
      expertProfileNumber,
      firmCode,
      subscriberNumber,
      subscriberPassword,
      subscriberSecurityCode,
      userId,
      licenseRegistrationNumber
    } = filogixDetails;
    try {
      await updateFilogixDetails({
        expertLoginId,
        expertProfileNumber,
        firmCode,
        subscriberNumber,
        subscriberPassword,
        subscriberSecurityCode,
        userId,
        licenseRegistrationNumber
      });
      context.commit(SET_FILOGIX_DETAILS, {
        expertLoginId,
        expertProfileNumber,
        firmCode,
        subscriberNumber,
        subscriberPassword,
        subscriberSecurityCode,
        userId,
        licenseRegistrationNumber
      });
    } catch (e) {
      var _e$responseJSON;
      const message = ((_e$responseJSON = e.responseJSON) == null ? void 0 : _e$responseJSON.message) || "failedToUpdateFilogixDetails";
      Err.handle(e, {}, message);
      throw e;
    }
  },
  [LOAD_SYNCED_EMAILS]: async context => {
    try {
      var _context;
      const syncedEmails = await getSyncedEmails();
      const defaultAccount = _findInstanceProperty(_context = syncedEmails.emails).call(_context, e => e.defaultAccount);
      const defaultAccountId = defaultAccount == null ? void 0 : defaultAccount.nylasAccountId;
      const {
        entities,
        result
      } = normalize(syncedEmails.emails, [emailsSchema]);
      context.commit(SET_SYNCED_EMAILS, {
        syncUrl: NYLAS_API,
        defaultAccountId,
        emails: (entities == null ? void 0 : entities.emails) || {},
        allIds: result
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadSyncedEmails");
    }
  },
  [UPDATE_PASSWORD]: async (context, {
    currentPassword,
    newPassword,
    email
  }) => {
    try {
      await changePassword(currentPassword, newPassword, email);
    } catch (e) {
      Err.handle(e, {}, "failedToUpdatePassword");
      throw e;
    }
  },
  [LOAD_BROKERAGE_OVERRIDES]: async context => {
    try {
      const overrides = await getBrokerageOverrides();
      context.commit(SET_BROKERAGE_OVERRIDES, overrides);
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_BROKERAGE_OVERRIDES]: async (context, override) => {
    try {
      context.commit(SET_BROKERAGE_OVERRIDES, override);
      await updateBrokerageOverrides(override);
      showToast("success", "brokeragesOverridesUpdated");
    } catch (e) {
      context.commit(SET_BROKERAGE_OVERRIDES, context.state.overrides);
      Err.handle(e);
    }
  },
  [LOAD_BROKERAGE_DATA]: async context => {
    try {
      const brokerageData = await getBrokerageData();
      context.commit(SET_BROKERAGE_DATA, brokerageData);
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_BROKERAGE_DATA]: async (context, brokerageData) => {
    try {
      const {
        defaultBrokerageAgent,
        subdomain,
        firmLicenseId
      } = brokerageData;
      await updateBrokerageData(defaultBrokerageAgent, subdomain, firmLicenseId);
      context.commit(SET_BROKERAGE_DATA, brokerageData);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_BROKERAGE_BOARDS]: async context => {
    try {
      const brokerageBoards = await getBrokerageBoards();
      context.commit(SET_BROKERAGE_BOARDS, brokerageBoards);
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_BROKERAGE_BOARDS]: async (context, brokerageBoards) => {
    try {
      const {
        displayFrench,
        statuses
      } = brokerageBoards;
      await updateBrokerageBoards(displayFrench, statuses);
      context.commit(SET_BROKERAGE_BOARDS, brokerageBoards);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPLOAD_LOGO]: async (context, {
    file,
    settingsType
  }) => {
    try {
      var _context2;
      const name = _replaceAllInstanceProperty(_context2 = file.name).call(_context2, " ", "-");
      const {
        url
      } = await getSignedURL(name, settingsType);
      await putS3Data(file, url);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_BROKERAGE_LOGO]: async () => {
    try {
      await updateBrokerageLogo();
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_NAV_LOGO]: async (context, {
    logoSrc,
    domain
  }) => {
    const navLogo = $(".logo-img");
    const time = new Date().getTime();
    const srcToUse = logoSrc || `${S3_BUCKET_URL}/portal-styles/${domain}?${time}`;
    navLogo.attr("src", srcToUse);
  },
  [REMOVE_PERSONAL_LOGO]: async () => {
    try {
      await removePersonalLogo();
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [REMOVE_BROKERAGE_LOGO]: async () => {
    try {
      await removeBrokerageLogo();
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_PERSONAL_STYLES]: async (context, {
    file,
    showToastr = false
  }) => {
    try {
      await updatePersonalStyles(file);
      if (showToastr) showToast("success", "themeUpdated");
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_BROKERAGE_STYLES]: async (context, {
    file,
    showToastr = false
  }) => {
    try {
      await updateBrokerageStyles(file);
      if (showToastr) showToast("success", "brokerageThemeUpdated");
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_PERSONAL_FAQ]: async context => {
    try {
      const {
        faq
      } = await getPersonalFaq();
      context.commit(SET_PERSONAL_FAQ, faq);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_BROKERAGE_FAQ]: async context => {
    try {
      const {
        faq
      } = await getBrokerageFaq();
      context.commit(SET_BROKERAGE_FAQ, faq);
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_PERSONAL_FAQ]: async (context, faq) => {
    try {
      await updatePersonalFaq({
        faq
      });
      context.commit(SET_PERSONAL_FAQ, faq);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_BROKERAGE_FAQ]: async (context, faq) => {
    try {
      await updateBrokerageFaq({
        faq
      });
      context.commit(SET_BROKERAGE_FAQ, faq);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [VALIDATE_SYNCED_EMAIL]: async (context, code) => {
    try {
      Amplitude.logEvent("Settings - Syncing nylas email", {
        page: "settings"
      });
      const result = await validateSyncedEmail(code);
      Amplitude.logEvent("Settings - nylas email synced", {
        page: "settings"
      });
      return result;
    } catch (e) {
      Err.handle(e, context, "somethingWentWrongAuthenticatingEmail");
    }
  },
  [UPDATE_DEFAULT_EMAIL]: async (context, accountId) => {
    try {
      await updateDefaultEmail(accountId);
      context.commit(SET_DEFAULT_EMAIL, accountId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_SYNCED_EMAIL]: async (context, accountId) => {
    try {
      await removeSyncedEmail(accountId);
      context.commit(DELETE_SYNC_EMAIL, accountId);
    } catch (e) {
      Err.handle(e, {}, "failedToDeleteEmail");
      throw e;
    }
  },
  [LOAD_SYNCED_CALENDARS]: async context => {
    try {
      const syncedCalendars = await getSyncedCalendars();
      const {
        entities,
        result
      } = normalize(syncedCalendars, [calendarsSchema]);
      context.commit(SET_SYNCED_CALENDARS, {
        calendars: (entities == null ? void 0 : entities.calendars) || {},
        allIds: result
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [REFRESH_TOKEN_NYLAS]: async (context, {
    grantId
  }) => {
    try {
      const response = await renewTokenNylas(grantId);
      if (isEmpty(response)) {
        return;
      }
      localStorage.setItem("grant", _JSON$stringify(response.grant));
      localStorage.setItem("user", _JSON$stringify(response.user));
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_REFRESH_TOKEN]: async (context, {
    grantId,
    refreshToken
  }) => {
    try {
      await updateRefreshToken(grantId, refreshToken);
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_SYNCED_CALENDARS]: async (context, changedSyncedCalendarIds) => {
    try {
      for (const calendarId of changedSyncedCalendarIds) {
        const {
          name,
          description,
          readOnly,
          nylasAccountId
        } = context.state.syncedCalendars.calendars[calendarId];
        const calendarIdToSend = calendarId.replace(`${nylasAccountId}-`, "");
        await toggleCalendarSync(nylasAccountId, calendarIdToSend, name, description, readOnly);
        context.commit(SET_CALENDAR_SYNC, calendarId);
      }
    } catch (e) {
      Err.handle(e, {}, "failedToUpdateCalendar");
      throw e;
    }
  },
  [LOAD_EXPERT_DETAILS]: async context => {
    try {
      const result = await pullFilogixDetailsFromExpert();
      if (result != null && result.shouldVerify) return result;
      const filogixDetails = result.userDetails;
      context.commit(SET_EXPERT_LENDER_DETAILS, filogixDetails);
      return filogixDetails;
    } catch (e) {
      var _e$responseJSON2;
      Err.handle(e);
      if (((_e$responseJSON2 = e.responseJSON) == null ? void 0 : _e$responseJSON2.code) === "InvalidOperationException") throw e;
    }
  },
  [VERIFY_EXPERT_PROFILE_NUMBER]: async (context, code) => {
    try {
      await verifyExpertProfileNumber(code);
      context.commit(SET_EXPERT_LENDER_DETAILS, {
        verified: true,
        hasImportCode: false
      });
      return true;
    } catch (e) {
      Err.handle(e, {}, "invalidEmailVerificationCode");
      context.commit(SET_EXPERT_LENDER_DETAILS, {
        verified: false
      });
      return false;
    }
  }
};
export default actions;